import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';
import { buttonAsLinkReset } from '../../utils/styles';
import { Grid } from '../grid';
import { MAX_WIDTH_DESKTOP_LARGE } from '../grid/constants';

export const HeroContainer = styled.div`
  position: relative;
  background: transparent;
`;

export const HeroBackground = styled.div<{
  $background?: string;
  $backgroundSplit: boolean;
  $backgroundSplitHeight: number;
  'data-testid'?: string;
}>`
  ${({ $background, $backgroundSplit, $backgroundSplitHeight }) =>
    $background
      ? $backgroundSplit
        ? `
          width: 100%;
          position: absolute;
          background: ${$background};
          height: ${$backgroundSplitHeight}px;

          @media ${mediaQuery.tablet} {
            height: calc(${$backgroundSplitHeight}px + ${primitive.$spacing3});
          }

          @media ${mediaQuery.desktopSmall} {
            height: calc(${$backgroundSplitHeight}px + ${primitive.$spacing3});
          }

          @media ${mediaQuery.desktopLarge} {
            height: calc(${$backgroundSplitHeight}px + ${primitive.$spacing6});
          }
        `
        : `
          width: 100%;
          height: 100%;
          position: absolute;
          background: ${$background};
        `
      : `background: transparent;`}
`;

export const HeroGrid = styled(Grid)<{ $reversed: boolean }>`
  row-gap: ${primitive.$spacing3};
  align-items: center;

  margin-block-start: ${primitive.$spacing4};
  margin-block-end: ${primitive.$spacing4};
  color: ${(p) =>
    p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light')};

  @media ${mediaQuery.desktopLarge} {
    margin-block-start: ${primitive.$spacing8};
    margin-block-end: ${primitive.$spacing8};
  }
`;

export const ImageWrapper = styled.div`
  overflow: hidden;
  width: 80%;
  margin: 0 10%;
  display: flex;
  align-items: center;
  justify-content: center;

  & > * {
    max-width: 100%;
    max-height: 100%;
  }

  @media ${mediaQuery.tablet} {
    margin: 0 auto;
    width: 80%;
  }
`;

export const HeroHeader = styled.div`
  font: ${(p) => p.theme.token('text-style-hero-header')};
`;

export const HeroSubheader = styled.div`
  margin-block-start: ${primitive.$spacing3};
  font: ${(p) => p.theme.token('text-style-hero-subheader')};

  @media ${mediaQuery.desktopLarge} {
    margin-block-start: ${primitive.$spacing6};
  }
`;

export const ButtonsWrapper = styled.div`
  margin-block-start: ${primitive.$spacing6};

  @media ${mediaQuery.tablet} {
    max-width: 270px;
    white-space: nowrap;
  }

  @media ${mediaQuery.desktopSmall} {
    max-width: 270px;
  }

  @media ${mediaQuery.desktopLarge} {
    margin-block-start: ${primitive.$spacing8};
    max-width: 270px;
  }
`;

export const TermsWrapper = styled.div<{ $reversed: boolean }>`
  font: ${(p) => p.theme.token('text-style-hero-terms')};
  color: ${(p) =>
    p.$reversed ? p.theme.token('text-hero-reversed') : p.theme.token('text-hero-light')};
  text-align: end;

  position: relative;
  padding-block-end: 1rem;
  margin: 0 6%;

  @media ${mediaQuery.desktopLarge} {
    max-width: ${MAX_WIDTH_DESKTOP_LARGE}px;
    margin: 0 auto;
  }
`;

export const Terms = styled.button`
  ${buttonAsLinkReset};
  color: inherit;

  &:hover {
    color: ${(p) => p.theme.token('text-link-hover')};
  }
`;
